import { IconMainMenuMetrics } from "@suse-o11y/icons";
import React from "react";

import { useNavigateToLink } from "../../components/react/link";
import { METRICS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemMetrics: React.FC = () => {
	const link = useNavigateToLink(METRICS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <MainMenuItemLayout icon={<IconMainMenuMetrics height={18} width={18} />} label="Metrics" to={link} />;
};
